import React, { FunctionComponent, useState, useEffect } from "react";
import { snakeCase } from "lodash";
import { useDebounce } from "react-use";

type TextInputFilterProps = {
  onChange: (text: string) => void;
  placeholder?: string;
  field: string;
  maxLength?: number;
  extraClass?: string;
  initialValue?: string;
  resetKey?: string;
};

const DEFAULT_WAIT = 300;
const TextInputFilter: FunctionComponent<TextInputFilterProps> = ({
  onChange,
  placeholder,
  field,
  maxLength,
  initialValue,
  extraClass = "",
  resetKey,
  ...props
}) => {
  const [innerValue, setInnerValue] = useState(initialValue ?? "");

  useEffect(() => {
    if (!resetKey) return undefined;
    setInnerValue("");
  }, [resetKey]);

  useEffect(() => {
    setInnerValue(initialValue ?? "");
  }, [initialValue]);

  useDebounce(() => onChange(innerValue), DEFAULT_WAIT, [innerValue]);

  return (
    <input
      type="text"
      className={`${extraClass} text-input-filter`}
      onChange={e => setInnerValue(e.target.value)}
      placeholder={placeholder}
      value={innerValue}
      maxLength={maxLength}
      data-testid={snakeCase(`text_filter_${field}_input`)}
      {...props}
    />
  );
};

export default TextInputFilter;
